export default function ContributionResults(props) {

    const renderItems = () => {
        const items = [];

        props.items.slice().reverse().forEach((item, i) => {
            if (item.timestamp) {
                const ts = formatDate(new Date(item.timestamp));
                let str = `[${ts}] jackpot: ${item.instance_id} ` +
                          `| contribution: ${item.contribution_amount} ${item.contribution_currency}`;
                if (item.win_pot_id) {
                    str += `| Win: ${item.win_amount} ${item.contribution_currency} (${item.win_pot_id})`;
                    items.push(<p key={i}><b>{str}</b></p>);
                } else {
                    items.push(<p key={i}>{str}</p>);
                }
            } else {
                items.push(<p key={i}><i>{item.message}</i></p>);
            }
        })
        return items;
    }

    return (
        <div className="ContributionResultsContainer">
            <div className="ContainerLabel">Results Log</div>
            {renderItems()}
        </div>
    )
}

function formatDate(date) {
    const pz = (v) => { return v < 10 ? "0"+v : v };
    return `${pz(date.getFullYear())}-${pz(date.getMonth()+1)}-${pz(date.getDate())} ${pz(date.getHours())}:${pz(date.getMinutes())}:${pz(date.getSeconds())}`;
}
